import {storeToken} from '../utils/local-storage';
import {push} from 'react-router-redux';

export function authMiddleware() {
    return next => action => {
        if (action.type.endsWith('FAILURE')) {
            if (action.payload && action.payload.status === 401) {
                storeToken('');
                return next(push('/login'));
            }
        }
        return next(action);
    };
}



// WEBPACK FOOTER //
// ./src/js/middleware/auth-middleware.js